<template>
  <div>
    <div v-if="loading">
      <b-spinner
                 variant="primary"
                 style="width: 3rem; height: 3rem"
                 label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
                   :submit-status="submitStatus"
                   action="Create"
                   :errors="errors"
                   :loading="loading"
                   v-on:handleSubmit="handleSubmit">
          <template v-slot:fields>


            <form-group label="Customer Type" v-if="selectedInvoice.partner_id == null && selectedInvoice.client_id == null">
              <b-form-radio
                v-model="customerType"
                name="customerType"
                value="Partner"
                @change="selectedInvoice.client_id = null"
                >Partner (Insurer,Broker,Repair Centre)</b-form-radio
              >
              <b-form-radio
                v-model="customerType"
                name="customerType"
                value="Client"
                @change="
                  selectedInvoice.partner_id = null
                "
                >Client (Walk-in)</b-form-radio
              >
            </form-group>

            <h3>{{ selectedCustomer }}</h3>

            <form-group label="Partner" v-if="customerType == 'Partner' && selectedInvoice.partner_id == null && selectedInvoice.client_id == null " :required="true">
              <b-form-select
                             @blur="$v.selectedInvoice.partner_id.$touch"
                             :class="{ 'is-invalid': $v.selectedInvoice.partner_id.$error }"
                                @input="onPartnerSelect"
                             v-model="selectedInvoice.partner_id">
                <b-form-select-option
                                      v-for="partner in partners"
                                      :value="partner.id"
                                      :key="partner.id">{{ partner.code }} : {{ partner.name }}</b-form-select-option>
              </b-form-select>
              <div class="invalid-feedback" v-if="!$v.selectedInvoice.partner_id.required">
                Please select partner
              </div>
            </form-group>

            <form-group label="Client" :required="true" v-if="customerType == 'Client' ">
              <b-form-select
                             @blur="$v.selectedInvoice.client_id.$touch"
                             :class="{ 'is-invalid': $v.selectedInvoice.client_id.$error }"
                             v-model="selectedInvoice.client_id">
                <b-form-select-option
                                      v-for="client in clients"
                                      :value="client.id"
                                      :key="client.id">{{ client.client_type }}: {{ client.name }} {{ client.surname }}</b-form-select-option>
              </b-form-select>
              <div class="invalid-feedback" v-if="!$v.selectedInvoice.client_id.required">
                Please select client
              </div>
            </form-group>

     

            <div>
              <table
                     class="table table-sm border"
                     v-if="invoiceLines.length > 0">
                <tr class="bg-light font-weight-bold">
                  <td>Part/Item</td>
                  <td>Quantity</td>
                  <td>Price</td>
                  <td>Total</td>
                  <td></td>
                </tr>
                <tr v-for="part in invoiceLines" :key="part.key">
                  <td>{{ part.code }} - {{ part.description }}</td>
                  <td>
                    {{ part.quantity }}
                  </td>
                  <td>
                    {{ part.selling_price }}
                  </td>
                  <td>
                    {{ part.quantity * part.selling_price }}
                  </td>
                  <td class="text-right">
                    <i
                       class="lni lni-trash text-danger pointer"
                       @click="removePart(part)"></i>
                  </td>
                </tr>
              </table>
            </div>



            <div class="border p-3 my-3" v-if="selectedInvoice.partner_id != null || selectedInvoice.client_id != null">


              <form-group label="Invoice Line Type">
                <b-form-radio
                  v-model="lineType"
                  name="lineType"
                  value="Part"
                  >Part from inventory</b-form-radio
                >
                <b-form-radio
                  v-model="lineType"
                  name="lineType"
                  value="FreeFormat"
                  >Free Format</b-form-radio
                >
              </form-group>

              <hr>

              <div v-if="lineType == 'Part' ">
            
                <form-group label="Parts Search">


                  <span v-if="selectedPart">
                    {{ selectedPart.code }} - {{ selectedPart.description }}
                  </span>

                  <v-select
                            ref="part"
                            label="name"
                            :options="parts"
                            :filterable="false"
                            @search="getParts"
                            :value="selectedPart"
                            @input="setSelectedPart">
                    <template slot="no-options">
                      Type to search parts by code or description
                    </template>
                    <template slot="option" slot-scope="c">
                      <div>{{ c.code }} - {{ c.description }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="c">
                      {{ c.description }}
                    </template>
                  </v-select>
                </form-group>


                <form-group label="Quantity" :required="true" class="mt-5">
                  <b-form-spinbutton ref="quantity" class="form-control" type="number" min="1" max="100000" step="1"
                                    v-model="selectedQuantity" />
                </form-group>

              

                <form-group label="Selling Price Per Part"  :required="true">
                  <input class="form-control" type="number" min="0" step="0.1" v-model="selectedSellingPrice" />
                </form-group>

                <b-button variant="info" class="btn-sm float-right text-white" @click="addPart">Add</b-button>
                <div style="clear: both"></div>

              </div>

              <div v-if="lineType == 'FreeFormat' ">

                <form-group label="Item Description" :required="true" >
                  <input class="form-control"        ref="description"  v-model="selectedFreeFormatDescription" />
                </form-group>

                <form-group label="Quantity" :required="true">
                  <b-form-spinbutton ref="quantity" class="form-control" type="number" min="1" max="100000" step="1"
                                    v-model="selectedQuantity" />
                </form-group>

                <form-group label="Selling Price Per Item" :required="true">
                  <input class="form-control" type="number" min="0" step="0.1" v-model="selectedSellingPrice" />
                </form-group>

                <b-button variant="info" class="btn-sm float-right text-white" @click="addFreeFormat">Add</b-button>
                <div style="clear: both"></div>

              </div>
              
            </div>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import accountRepo from "@/api/repos/accountRepo";
import { requiredIf } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  validations: {
    selectedInvoice: {
      partner_id: {
        requiredIf: requiredIf(function () {
          return this.customerType === "Partner";
        }),
      },
      client_id: {
        requiredIf: requiredIf(function () {
          return this.customerType === "Client";
        }),
      },
    },
  },

  mounted() {
    this.getCreatedData();
  },

  data() {
    return {
      customerType: 'Client',
      lineType:'Part',
      selectedInvoice: {},
      selectedCustomer: "",
      lastLineId :1,
      parts: [],
      selectedPart: null,
      selectedSellingPrice: "",
      selectedQuantity: 1,
      selectedFreeFormatDescription:"",
      invoiceLines: [],
      clients: [],
      partners: [],
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
      partKey: 1
    };
  },

  methods: {
    async getCreatedData() {
      try {
        this.loading = true;
        let { data } = await accountRepo.invoiceCreateRelatedData();
        this.partners = data.partners;
        this.clients = data.clients;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    setSelectedPart(value) {
      this.selectedPart = value

      if (this.customerType == 'Client'){
        this.selectedSellingPrice = parseFloat(value.selling_price_client)
      }else{

        var markup = this.partners.filter(x => x.id == this.selectedInvoice.partner_id)[0].parameters.parts_markup;
     
        this.selectedSellingPrice = (parseFloat(value.current_cost) + ((parseFloat(value.current_cost) * markup)/100)).toFixed(2);
      }
      
      this.parts = []
      this.$refs.quantity.focus()
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";


      if (this.invoiceLines.length == 0) {
        this.$root.$bvToast.toast("No Parts", {
          title: "No Parts",
          autoHideDelay: 2000,
          variant: "danger",
        });
        this.loading = false;
        this.submitStatus = null;

        return;
      }
      this.selectedInvoice.lines = this.invoiceLines;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await accountRepo.invoiceCreate(this.selectedInvoice);
          this.$emit("invoiceCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },

  onPartnerSelect(partnerId) {
    const selectedPartner = this.partners.find(partner => partner.id === partnerId);
    this.selectedCustomer = selectedPartner ? selectedPartner.name : null;
  },


    getParts(search) {
      if (search.length > 1) {
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(() => {
          this.partSearch(search);
        }, 250);
      }
    },
    addPart() {
      if (this.selectedPart == null || this.selectedSellingPrice == null || this.selectedSellingPrice == "") {
        this.$root.$bvToast.toast("Missing info", {
          title: "Fill in info",
          autoHideDelay: 3000,
          variant: "danger",
        });

        return false;
      }
      this.lastLineId = this.lastLineId + 1;
      this.invoiceLines.push({
        key:  this.lastLineId,
        part_id: this.selectedPart.id,
        code: this.selectedPart.code,
        description: this.selectedPart.description,
        quantity: this.selectedQuantity,
        selling_price: this.selectedSellingPrice,
        current_cost: this.selectedPart.current_cost
      });

      this.selectedPart = null;
      this.selectedSellingPrice = null;
      this.selectedQuantity = 1;
      this.parts = []
      this.$refs.part.$refs.search.focus()
    },

    addFreeFormat() {
      if (this.selectedFreeFormatDescription == null || this.selectedFreeFormatDescription == "" || this.selectedSellingPrice == null || this.selectedSellingPrice == "") {
        this.$root.$bvToast.toast("Missing info", {
          title: "Fill in info",
          autoHideDelay: 3000,
          variant: "danger",
        });

        return false;
      }
      this.lastLineId = this.lastLineId + 1;
      this.invoiceLines.push({
        key: this.lastLineId,
        part_id: null,
        code: 'FF',
        description: this.selectedFreeFormatDescription,
        quantity: this.selectedQuantity,
        selling_price: this.selectedSellingPrice,
      });

      this.selectedFreeFormatDescription= null;
      this.selectedSellingPrice = null;
      this.selectedQuantity = 1;
      this.$refs.description.focus()
    },


    removePart(part) {
      this.invoiceLines = this.invoiceLines.filter((x) => x != part);
    },

    async partSearch(search) {
      try {
        let { data } = await accountRepo.invoiceCreateGetParts(search);
        this.parts = data.parts;
      } finally {
        this.loading = false;
      }
    },
  },

  
  
};
</script>

<style></style>
